import axios from "axios"

export const xhr = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: false, // default
});